export const COUNSEL_REQUEST_TYPES = { SHORT: "COUNSEL_REQUEST_SHORT", LONG: "COUNSEL_REQUEST_LONG" };
export const USER_TYPES = { INDIVIDUAL: "USER_INDIVIDUAL", ORGANIZATION: "USER_ORGANIZATION" };
export const INDIVIDUAL_KINDS = {
    SUPPORTER: { value: "SUPPORTER", text: "전자제조지원단" },
    STUDENT: { value: "STUDENT", text: "인력양성사업참여학생" },
    ELSE: { value: "ELSE", text: "기타" },
};
export const EXPERT_DESCRIPTION_TERMS = ["기술정보", "학위", "지식재산권", "논문", "제품", "서비스", "기타"];
